import React, {useState, useEffect, useRef} from 'react';
import TinyEditor from './TinyEditor';
import photos from './photos';
import '../style/presentation.css'

export default function Presentation(props) {
  const [presentImg, setPresentImg] = useState([])
  const changePhotos = useRef(null);
  const i = useRef(0);
  const w = window.screen.width;
  const dispImages = () => {
    if (document.querySelector('#presentImg0')) {
      document.querySelector('#presentImg0').style.animation = 'showImg 1.5s linear';
    }
    if (document.querySelector('#presentImg1')) {
      document.querySelector('#presentImg1').style.animation = 'showImg 1.5s linear';
    }
    if (document.querySelector('#presentImg2')) {
      document.querySelector('#presentImg2').style.animation = 'showImg 1.5s linear';
    }
  }
  const hideImages = () => {
    setTimeout(() => {
      if (document.querySelector('#presentImg0')) {
        document.querySelector('#presentImg0').style.animation = 'hideImg 1s linear';
      }
      if (document.querySelector('#presentImg1')) {
        document.querySelector('#presentImg1').style.animation = 'hideImg 1s linear';
      }
      if (document.querySelector('#presentImg2')) {
        document.querySelector('#presentImg2').style.animation = 'hideImg 1s linear';
      }
    }, 4100);
  }
  const dispatchImages = () => {
    if (w > 1290) {
      setPresentImg([photos[i.current], photos[i.current + 1], photos[i.current + 2]]);
    }
    if (w > 875 && w <= 1290) {
      setPresentImg([photos[i.current], photos[i.current + 1]]);
    }
    if (w <= 875) {
      setPresentImg([photos[i.current]]);
    }
    hideImages();
  };
  useEffect(() => {
    var photosLen = photos.length;
    if (presentImg.length === 0) {
      dispatchImages();
    }
    if (changePhotos.current === null) {
      changePhotos.current = setInterval( 
        () => {
          dispImages();
          hideImages();
          i.current = i.current < photosLen - 3 ? i.current + 1 : 0;
          dispatchImages();
        }, 5000)
      }
    return () => {
      clearInterval(changePhotos.current);
      changePhotos.current = null;
    }

  }, [presentImg])
  return (
    <div>
      {props.mode === 'user' && (
        <div style={{overflowY: 'auto'}}>
          <div className="presentImgDiv">
            {presentImg.length >= 0 && presentImg.map((img, index) => (
              <img
                src={process.env.PUBLIC_URL + '/' + img.src}
                key={'presImg' + index}
                className="presentImg"
                id={'presentImg' + index}
                alt={'presentattion image ' + index} /> 
            ))}
          </div>
          <div className="presentation_container noselect">
            <div className="presentation_title">
              <h3>Paragraphe 1</h3>
            </div>
            <div className="presentation_parag">
              <p className="presentation_text">
                <span style={{marginLeft:'50px'}}></span>
                Le Lorem Ipsum est simplement du faux texte employé dans la composition et 
                la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de 
                l'imprimerie depuis les années 1500, quand un imprimeur anonyme assembla 
                ensemble des morceaux de texte pour réaliser un livre spécimen de polices de texte.
              </p>
            </div>
            <div className="presentation_title" style={{marginTop: '130px'}}>
              <h3>Paragraphe 2</h3>
            </div>
            <div className="presentation_parag">
              <p className="presentation_text">
                <span style={{marginLeft:'50px'}}></span>
                Le Lorem Ipsum est simplement du faux texte employé dans la composition et 
                la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de 
                l'imprimerie depuis les années 1500, quand un imprimeur anonyme assembla 
                ensemble des morceaux de texte pour réaliser un livre spécimen de polices de 
                texte. Il n'a pas fait que survivre cinq siècles, mais s'est aussi adapté à la 
                bureautique informatique, sans que son contenu n'en soit modifié. Il a été 
                popularisé dans les années 1960 grâce à la vente de feuilles Letraset contenant 
                des passages du Lorem Ipsum, et, plus récemment, par son inclusion dans des 
                applications de mise en page de texte, comme Aldus PageMaker.
              </p>
            </div>
            <div className="presentation_title" style={{marginTop: '100px'}}>
              <h3>Paragraphe 3</h3>
            </div>
            <div className="presentation_parag">
              <p className="presentation_text">
                <span style={{marginLeft:'50px'}}></span>
              On sait depuis longtemps que travailler avec du texte lisible et contenant du 
              sens est source de distractions, et empêche de se concentrer sur la mise en page 
              elle-même. L'avantage du Lorem Ipsum sur un texte générique comme 'Du texte. 
              Du texte. Du texte.' est qu'il possède une distribution de lettres plus ou moins 
              normale, et en tout cas comparable avec celle du français standard. De nombreuses 
              suites logicielles de mise en page ou éditeurs de sites Web ont fait du Lorem 
              Ipsum leur faux texte par défaut, et une recherche pour 'Lorem Ipsum' vous 
              conduira vers de nombreux sites qui n'en sont encore qu'à leur phase de 
              construction. Plusieurs versions sont apparues avec le temps, parfois par 
              accident, souvent intentionnellement (histoire d'y rajouter de petits clins d'oeil, 
              voire des phrases embarassantes).
              </p>
            </div>
          </div>
          <div style={{marginBottom: '150px'}}></div>
        </div>
      )}
      {props.mode === 'admin' && <TinyEditor />}
    </div>
  )
}
